module.exports = __webpack_public_path__ + "img/clock.8412a471.svg";